module.exports = __webpack_public_path__ + "img/thumbnail_Axolotl_u_xanthic.46e5c213.png";